export enum EmploymentStatus {
    FULL_TIME = 'FULL_TIME',
    PART_TIME = 'PART_TIME',
    FREELANCER = 'FREELANCER',
    BUSINESS_OWNER = 'BUSINESS_OWNER',
    SEARCHING = 'SEARCHING',
    STAY_AT_HOME_PARENT = 'STAY_AT_HOME_PARENT',
    UNEMPLOYED = 'UNEMPLOYED',
    RETIRED = 'RETIRED',
}
